import {createContext, useCallback, useContext} from "react";
import useApiService from "./ApiService";
import CONFIG from "./CONFIG";

const ChatAnalyticsApiContext = createContext();

export function ChatAnalyticsApiProvider({ children }) {
    const { get } = useApiService(CONFIG.SERVER_CHANNEL);

    const getTotalChatAnalytics = useCallback(async (start_date, end_date) => {
        try {
            const response = await get(
                `/v1/analytics/channel?start_date=${start_date}&end_date=${end_date}`
            );
            return response.data;
        } catch (error) {
            console.error("Error fetching total chat analytics:", error);
            throw error;
        }
    }, [get]);

    const getDetailedChatAnalytics = useCallback(async (start_date, end_date, skip, limit) => {
        try {
            const response = await get(
                `/v1/analytics/channel/detailed?start_date=${start_date}&end_date=${end_date}&skip=${skip}&limit=${limit}`
            );
            console.log("Detailed chat analytics response:", response.data);
            return response.data;
        } catch (error) {
            console.error("Error fetching detailed chat analytics:", error);
            throw error;
        }
    }, [get]);

    const getTokenAnalytics = useCallback(async (start_date, end_date) => {
        try {
            const response = await get(
                `/v1/analytics/channel/tokens?start_date=${start_date}&end_date=${end_date}`
            );
            return response.data;
        } catch (error) {
            console.error("Error fetching token analytics:", error);
            throw error;
        }
    }, [get]);

    return (
        <ChatAnalyticsApiContext.Provider
            value={{ getTotalChatAnalytics, getDetailedChatAnalytics, getTokenAnalytics }}
        >
            {children}
        </ChatAnalyticsApiContext.Provider>
    );
}

export function useChatAnalyticsApi() {
    const context = useContext(ChatAnalyticsApiContext);
    if (!context) {
        throw new Error("useChatAnalyticsApi must be used within a ChatAnalyticsApiProvider");
    }
    return context;
}
